import { EstimatesPermissions } from './estimates.permissions';
import { EstimatesRoles } from './estimates.roles';

export const estimatesMappings = {
  [EstimatesPermissions.GET_DEFAULT_ITEMS]: [
    EstimatesRoles.DEFAULT_ITEMS_VIEWER,
  ],
  [EstimatesPermissions.MANAGE_DEFAULT_ITEMS]: [
    EstimatesRoles.DEFAULT_ITEMS_MANAGER,
  ],
  [EstimatesPermissions.CREATE_ESTIMATE]: [EstimatesRoles.CREATOR],
  [EstimatesPermissions.UPDATE_ESTIMATE]: [EstimatesRoles.EDITOR],
  [EstimatesPermissions.ARCHIVE_ESTIMATE]: [EstimatesRoles.ARCHIVER],
  [EstimatesPermissions.UNARCHIVE_ESTIMATE]: [EstimatesRoles.ARCHIVER],
  [EstimatesPermissions.SEND_ESTIMATE]: [EstimatesRoles.PERSISTER_SENDER],
  [EstimatesPermissions.DUPLICATE_ESTIMATE]: [EstimatesRoles.CREATOR],
};
